export const Eyebrow = ({ children, className = "", start = false, "data-testid": testId }) => {
  return (
    <span
      className={`eyebrow ${start ? "eyebrow-start" : ""} ${className}`}
      data-testid={testId}
    >
      {children}
    </span>
  );
};
